import { useCallback, useEffect, useState } from 'react';
import { throttle } from 'lodash';

interface WindowSize {
  width: number | undefined;
  height: number | undefined;
  breakpoint: '' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

// Returns an object containing the window's width and height.
export function useWindowSize(): WindowSize {
  const [windowSize, setWindowSize] = useState<WindowSize>({
    width: undefined,
    height: undefined,
    breakpoint: '',
  });

  const calcBreakpoint = (width) => {
    if (width > 1536) {
      return '2xl';
    } else if (width > 1280) {
      return 'xl';
    } else if (width > 1024) {
      return 'lg';
    } else if (width > 768) {
      return 'md';
    } else if (width > 640) {
      return 'sm';
    }
    return '';
  };

  const handleResize = useCallback(
    throttle(() => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
        breakpoint: calcBreakpoint(window.innerWidth),
      });
    }, 1000),
    []
  );

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}
